import { all, spawn } from 'redux-saga/effects';
import aboutUsSaga from './aboutUs/saga';
import companyBenefitsSaga from './companyBenefits/saga';
import companyBrandSaga from './companyBrand/saga';
import companyTeamMembersSaga from './companyTeamMembers/saga';
import companyTechTags from './companyTechTags/saga';
import contactSectionSaga from './contactSection/saga';
import generalSaga from './general/saga';
import myCompanySectionSaga from './myCompanySection/saga';
import profilePostSaga from './profilePost/saga';
import selectionProcessSaga from './selectionProcess/saga';

export default function* rootSaga() {
  yield all([
    spawn(generalSaga),
    spawn(profilePostSaga),
    spawn(aboutUsSaga),
    spawn(companyBrandSaga),
    spawn(companyBenefitsSaga),
    spawn(contactSectionSaga),
    spawn(companyTeamMembersSaga),
    spawn(selectionProcessSaga),
    spawn(myCompanySectionSaga),
    spawn(companyTechTags),
  ]);
}
